import * as React from "react";
import { SVGProps } from "react";

interface SurveyFileSvgProps extends SVGProps<SVGSVGElement> {
	size?: "md" | "sx";
}

export const SurveyFileSvg = (props: SurveyFileSvgProps) => {
	const { size = "md", ...rest } = props;

	if (size === "sx") {
		return (
			<svg
				width={18}
				height={18}
				viewBox="0 0 18 18"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
				{...rest}
			>
				<path
					d="M9.97211 0C10.5023 0 11.0108 0.210507 11.3858 0.585255L16.0638 5.25973C16.4392 5.63484 16.6501 6.14378 16.6501 6.67447V15.9C16.6501 17.0598 15.6911 18 14.5081 18H3.4921C2.3091 18 1.3501 17.0598 1.3501 15.9V2.1C1.3501 0.940202 2.3091 0 3.4921 0H9.97211Z"
					fill="#0050FF"
				/>
				<g filter="url(#filter0_d_649_6363)">
					<path
						d="M15.355 4.9936C15.668 5.30917 15.4445 5.8457 15 5.8457H13.0502C11.8904 5.8457 10.8441 4.82557 10.8441 3.69474V1.65982C10.8441 1.21338 11.3847 0.990745 11.6991 1.30771L15.355 4.9936Z"
						fill="white"
						fillOpacity={0.24}
						shapeRendering="crispEdges"
					/>
				</g>
				<path
					d="M10.7982 7.2002L10.798 7.20524L10.8 7.20526V13.5002H10.2752L10.2751 13.4994H8.69685L8.17215 13.5002L8.17203 13.4994H7.13326L6.60847 13.5002L6.60844 13.4994H5.02656L4.50185 13.5002L4.50173 13.4994L4.50076 12.975L4.50173 12.9749V11.3899L4.5004 10.8654L4.50173 10.8653V9.28029L4.5 9.28042V8.75584L4.50173 8.75574V7.72475L4.5 7.72477V7.2002H10.7982ZM6.60844 11.3899H5.02656V12.9749H6.60844V11.3899ZM8.17203 11.3899H7.13326V12.9749H8.17203V11.3899ZM10.2751 11.3899H8.69685V12.9749H10.2751V11.3899ZM6.60844 9.28029H5.02656V10.8653H6.60844V9.28029ZM8.17203 9.28029H7.13326V10.8653H8.17203V9.28029ZM10.2751 9.28029H8.69685V10.8653H10.2751V9.28029ZM10.2751 7.72475H5.02656V8.75574H10.2751V7.72475Z"
					fill="white"
				/>
				<defs>
					<filter
						id="filter0_d_649_6363"
						x={8.84424}
						y={1.15869}
						width={8.65674}
						height={8.68701}
						filterUnits="userSpaceOnUse"
						colorInterpolationFilters="sRGB"
					>
						<feFlood floodOpacity={0} result="BackgroundImageFix" />
						<feColorMatrix
							in="SourceAlpha"
							type="matrix"
							values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
							result="hardAlpha"
						/>
						<feOffset dy={2} />
						<feGaussianBlur stdDeviation={1} />
						<feComposite in2="hardAlpha" operator="out" />
						<feColorMatrix
							type="matrix"
							values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
						/>
						<feBlend
							mode="normal"
							in2="BackgroundImageFix"
							result="effect1_dropShadow_649_6363"
						/>
						<feBlend
							mode="normal"
							in="SourceGraphic"
							in2="effect1_dropShadow_649_6363"
							result="shape"
						/>
					</filter>
				</defs>
			</svg>
		);
	}

	return (
		<svg
			width={40}
			height={40}
			viewBox="0 0 40 40"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...rest}
		>
			<path
				d="M22.5721 3C23.1022 3 23.6107 3.21051 23.9857 3.58526L33.8637 13.4558C34.2391 13.8309 34.4501 14.3399 34.4501 14.8706V33.0333C34.4501 35.2241 32.6386 37 30.404 37H9.59605C7.3615 37 5.55005 35.2241 5.55005 33.0333V6.96667C5.55005 4.77594 7.3615 3 9.59605 3H22.5721Z"
				fill="#9723F9"
			/>
			<g filter="url(#filter0_d_335_2969)">
				<path
					d="M32.7549 13.1896C33.0679 13.5052 32.8444 14.0417 32.3999 14.0417H27.6501C25.4594 14.0417 23.4831 12.1148 23.4831 9.97881V5.05586C23.4831 4.60942 24.0237 4.38679 24.3381 4.70376L32.7549 13.1896Z"
					fill="white"
					fillOpacity={0.24}
					shapeRendering="crispEdges"
				/>
			</g>
			<path
				d="M24 22.9999L16 22.9999M24 18.9999L16 18.9999M24 26.9999L16 26.9999M13.3333 22.9999C13.3333 23.3681 13.0349 23.6666 12.6667 23.6666C12.2985 23.6666 12 23.3681 12 22.9999C12 22.6317 12.2985 22.3333 12.6667 22.3333C13.0349 22.3333 13.3333 22.6317 13.3333 22.9999ZM13.3333 18.9999C13.3333 19.3681 13.0349 19.6666 12.6667 19.6666C12.2985 19.6666 12 19.3681 12 18.9999C12 18.6317 12.2985 18.3333 12.6667 18.3333C13.0349 18.3333 13.3333 18.6317 13.3333 18.9999ZM13.3333 26.9999C13.3333 27.3681 13.0349 27.6666 12.6667 27.6666C12.2985 27.6666 12 27.3681 12 26.9999C12 26.6317 12.2985 26.3333 12.6667 26.3333C13.0349 26.3333 13.3333 26.6317 13.3333 26.9999Z"
				stroke="white"
				strokeWidth={1.33333}
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<defs>
				<filter
					id="filter0_d_335_2969"
					x={21.4832}
					y={4.55493}
					width={13.4177}
					height={13.4868}
					filterUnits="userSpaceOnUse"
					colorInterpolationFilters="sRGB"
				>
					<feFlood floodOpacity={0} result="BackgroundImageFix" />
					<feColorMatrix
						in="SourceAlpha"
						type="matrix"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
						result="hardAlpha"
					/>
					<feOffset dy={2} />
					<feGaussianBlur stdDeviation={1} />
					<feComposite in2="hardAlpha" operator="out" />
					<feColorMatrix
						type="matrix"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
					/>
					<feBlend
						mode="normal"
						in2="BackgroundImageFix"
						result="effect1_dropShadow_335_2969"
					/>
					<feBlend
						mode="normal"
						in="SourceGraphic"
						in2="effect1_dropShadow_335_2969"
						result="shape"
					/>
				</filter>
			</defs>
		</svg>
	);
};
